import { api } from './client'

export const listProgramVideos = (pid) =>
  api.get(`/videos/programs/${pid}`).then((r) => r.data)

export const getVideo = (videoId) =>
  api.get(`/videos/${videoId}`).then((r) => r.data)

export const uploadVideoForLesson = (pid, lessonId, file, { title, durationSec } = {}) => {
  const fd = new FormData()
  fd.append('file', file)
  if (title) fd.append('title', title)
  if (typeof durationSec === 'number') fd.append('durationSec', String(durationSec))
  return api
    .post(`/videos/programs/${pid}/lessons/${lessonId}/upload`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

export const deleteVideo = (pid, videoId) =>
  api.delete(`/videos/programs/${pid}/${videoId}`).then((r) => r.data)

export const updateWatchProgress = (pid, videoId, { watchPct, completed = false }) =>
  api
    .post(`/videos/programs/${pid}/${videoId}/watch`, { watchPct, completed })
    .then((r) => r.data)

export const listBookmarks = (pid, videoId) =>
  api.get(`/videos/programs/${pid}/${videoId}/bookmarks`).then((r) => r.data)

export const addBookmark = (pid, videoId, { timestampSec, note }) =>
  api
    .post(`/videos/programs/${pid}/${videoId}/bookmark`, { timestampSec, note })
    .then((r) => r.data)

export const deleteBookmark = (pid, bookmarkId) =>
  api.delete(`/videos/programs/${pid}/bookmarks/${bookmarkId}`).then((r) => r.data)
